import type { FieldsCartComponent } from './fields-cart.type'

export const ORDER_FORM_CART: FieldsCartComponent[] = [
  {
    id: '1',
    label: 'Desc 1',
    campo: 'discount1',
    enabled: true,
    visible: true,
    fieldJson: 'desconto1',
  },
  {
    id: '2',
    label: 'Desc 2',
    campo: 'discount2',
    enabled: true,
    visible: true,
    fieldJson: 'desconto2',
  },
  {
    id: '3',
    label: 'Desc 3',
    campo: 'discount3',
    enabled: true,
    visible: true,
    fieldJson: 'desconto3',
  },
  {
    id: '4',
    label: 'Desc 4',
    campo: 'discount4',
    enabled: true,
    visible: true,
    fieldJson: 'desconto4',
  },
]
